import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";

const GartnerInsights = ({ data }) => {
    const { subtitle, title, cta } = data && data.cardItem ? data.cardItem : {};

    const generateStarSpans = (rating) => {
        const fullStars = Math.floor(rating);
        const partialStarWidth = (rating % 1) * 100;

        const stars = [];
        /* eslint-disable no-plusplus */
        for (let i = 0; i < fullStars; i++) {
            stars.push(<span key={i} className=" full-start w-3.5 h-3.25 ml-0.5 inline-flex bg-starFullIcon" />);
        }

        if (partialStarWidth > 0) {
            stars.push(<span key="half" className=" half-start w-3.5 h-3.25 inline-flex bg-starHalfIcon" />);
        }

        return stars;
    };
    return (
        <section id={data?.customId}>
            <div className="container">
                <div className="row">
                    <div className="col-12  ">
                        <div className="text-center relative bg-blue rounded md:flex md:justify-center md:items-center py-5 px-10 overflow-hidden w-full">
                            <div
                                className="absolute -left-16.5 -top-17.25 w-64 h-[202px] bg-contain"
                                style={{
                                    backgroundImage: data?.backgroundImage
                                        ? `url(${data?.backgroundImage?.[0]?.secure_url})`
                                        : null,
                                    transform: "scaleX(-1)",
                                }}
                            />
                            <div
                                className="absolute -right-16.5 -top-17.25 w-64 h-[202px] bg-contain"
                                style={
                                    data?.backgroundImage
                                        ? { backgroundImage: `url(${data?.backgroundImage?.[0]?.secure_url})` }
                                        : null
                                }
                            />
                            {subtitle && (
                                <div className=" flex justify-center mb-2.5 md:mb-0">
                                    <div className=" pr-4.5">
                                        <p className=" text-white">{subtitle}</p>
                                    </div>
                                    <div>{generateStarSpans(subtitle)}</div>
                                </div>
                            )}
                            {title && (
                                <div className=" relative md:pl-5  mb-2.5 md:mb-0">
                                    <h2 className="body text-white">{title}</h2>
                                </div>
                            )}
                            {cta.map((linkData) => (
                                <Cta key={linkData.id} className="white-link md:pl-20" data={linkData} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GartnerInsights;
